import { ArrowUpRight } from "lucide-react";
import { EMAIL, NAV } from "../../data/content";

export const Footer = () => (
  <footer id="contact" className="bg-[#0A0A0A] border-t border-white/10" data-testid="footer">
    <div className="px-6 lg:px-12 py-24 grid lg:grid-cols-2 gap-16">
      <div>
        <p className="font-mono text-xs tracking-[0.35em] text-white/50 flex items-center gap-4">
          CORRESPONDENCE <span className="inline-block w-16 h-px bg-white/20" />
        </p>
        <h2 className="mt-8 font-display text-4xl sm:text-5xl leading-[1.1] text-white" data-testid="contact-headline">
          For institutional enquiries and partnerships.
        </h2>
        <a
          href={`mailto:${EMAIL}`}
          data-testid="contact-email-btn"
          className="mt-10 inline-flex items-center gap-3 border border-white/30 px-8 py-4 font-mono text-sm tracking-[0.2em] text-white hover:bg-white hover:text-black transition-colors duration-300"
        >
          {EMAIL.toUpperCase()} <ArrowUpRight className="w-4 h-4" />
        </a>
      </div>
      <div className="flex flex-col justify-end">
        <nav className="grid grid-cols-2 gap-4" data-testid="footer-nav">
          {NAV.map((item) => (
            <a
              key={item.label}
              href={item.href}
              data-testid={`footer-nav-${item.label.toLowerCase()}`}
              className="font-mono text-xs tracking-[0.25em] text-white/50 hover:text-white transition-colors duration-300"
            >
              {item.label}
            </a>
          ))}
        </nav>
      </div>
    </div>
    <div className="border-t border-white/10 px-6 lg:px-12 py-10 flex flex-col md:flex-row md:items-end justify-between gap-8">
      <div>
        <p className="font-mono text-base lg:text-lg tracking-[0.25em] text-white">A-SQUARE GROUP</p>
        <p className="mt-2 font-mono text-[10px] tracking-[0.35em] text-white/40">
          GOVERNANCE · SYSTEMS · INTELLIGENCE
        </p>
      </div>
      <p className="font-mono text-[10px] tracking-[0.25em] text-white/40" data-testid="footer-copyright">
        A-SQUARE GROUP © 2011-2026 · ALL RIGHTS RESERVED
      </p>
    </div>
  </footer>
);
